// import { useEffect, useState, useCallback, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import useSocket from "./useSocket";
// import { GetAPI, PatchAPI } from "../../ApiServices/ApiServices";

// const REDIRECT_MAP = {
//   appointment_details: (n) => `/appointments/${n.appointment_id}`,
//   appointments_list: () => `/appointments`,
//   followups_module: () => `/followups`,
//   dashboard: () => `/dashboard`,
//   profile_section: () => `/profile`,
// };

// const useNotifications = () => {
//   const socket = useSocket();
//   const navigate = useNavigate();

//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [loading, setLoading] = useState(true);

//   const joinedRef = useRef(false);

//   const doctorData = JSON.parse(
//     localStorage.getItem("doctorData") || "{}"
//   );

//   const doctorId = doctorData?.id;

//   //-----------------------------------------
//   // Fetch Notifications
//   //-----------------------------------------

//   const fetchNotifications = useCallback(async () => {
//     setLoading(true);

//     await GetAPI(
//       "/doctor/notifications?page=1&limit=20",
//       (res) => {
//         if (res.success) {
//           setNotifications(res.notifications || []);

//           setUnreadCount(
//             (res.notifications || []).filter((n) => !n.is_read).length
//           );
//         }

//         setLoading(false);
//       }
//     );
//   }, []);

//   //-----------------------------------------
//   // Mark Read
//   //-----------------------------------------

//   const markAsRead = useCallback(
//     async (notificationId) => {
//       setNotifications((prev) =>
//         prev.map((n) =>
//           n.id === notificationId
//             ? { ...n, is_read: true }
//             : n
//         )
//       );

//       setUnreadCount((prev) => Math.max(0, prev - 1));

//       await PatchAPI(
//         {
//           url: `/doctor/notifications/${notificationId}/read`,
//           data: {},
//         },
//         (res) => {
//           if (!res.success) {
//             fetchNotifications();
//           }
//         }
//       );
//     },
//     [fetchNotifications]
//   );

//   //-----------------------------------------
//   // Mark All Read
//   //-----------------------------------------

//   const markAllAsRead = useCallback(async () => {
//     setNotifications((prev) =>
//       prev.map((n) => ({
//         ...n,
//         is_read: true,
//       }))
//     );

//     setUnreadCount(0);

//     await PatchAPI(
//       {
//         url: "/doctor/notifications/read-all",
//         data: {},
//       },
//       (res) => {
//         if (!res.success) {
//           fetchNotifications();
//         }
//       }
//     );
//   }, [fetchNotifications]);

//   //-----------------------------------------
//   // Click Notification
//   //-----------------------------------------

//   const handleNotificationClick = useCallback(
//     (notification) => {
//       if (!notification.is_read) {
//         markAsRead(notification.id);
//       }

//       const route = REDIRECT_MAP[notification.redirect_to];

//       if (route) {
//         navigate(route(notification));
//       }
//     },
//     [navigate, markAsRead]
//   );

//   //-----------------------------------------
//   // Initial Fetch
//   //-----------------------------------------

//   useEffect(() => {
//     fetchNotifications();
//   }, [fetchNotifications]);

//   //-----------------------------------------
//   // Socket Events
//   //-----------------------------------------

//   useEffect(() => {
//     if (!socket) return;

//     if (!socket.connected) {
//       socket.connect();
//     }

//     const joinDoctorRoom = () => {
//       if (!doctorId) return;

//       console.log("Joining doctor room:", doctorId);

//       socket.emit("join:doctor", {
//         doctor_id: doctorId,
//       });
//     };

//     if (socket.connected) {
//       joinDoctorRoom();
//     } else {
//       socket.once("connect", joinDoctorRoom);
//     }

//     socket.on("join:doctor:ack", (data) => {
//       console.log("Joined Room:", data);
//       joinedRef.current = true;
//     });

//     socket.on("doctor:notification", (payload) => {
//       console.log("Notification Received:", payload);

//       const { event, data } = payload;

//       if (event !== "new_notification") return;

//       setNotifications((prev) => {
//         if (prev.some((n) => n.id === data.id)) {
//           return prev;
//         }

//         return [data, ...prev];
//       });

//       setUnreadCount((prev) => prev + 1);
//     });

//     socket.on("doctor:notification:unread_count", ({ unread_count }) => {
//       console.log("Unread Count:", unread_count);
//       setUnreadCount(unread_count);
//     });

//     socket.onAny((event, ...args) => {
//       console.log("Socket Event:", event, args);
//     });

//     return () => {
//       socket.off("join:doctor:ack");
//       socket.off("doctor:notification");
//       socket.off("doctor:notification:unread_count");
//       socket.off("connect", joinDoctorRoom);
//       socket.offAny();
//     };
//   }, [socket, doctorId]);

//   return {
//     notifications,
//     unreadCount,
//     loading,
//     markAsRead,
//     markAllAsRead,
//     handleNotificationClick,
//     refetch: fetchNotifications,
//   };
// };

// export default useNotifications;

import { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useSocket from "./useSocket";
import { DeleteAPI, GetAPI, PatchAPI } from "../../ApiServices/ApiServices";

const REDIRECT_MAP = {
  appointment_details: (n) => `/appointments/view-details/${n.appointment_id}`,
  appointments_list: () => `/appointments`,
  followups_module: () => `/followups`,
  dashboard: () => `/`,
  profile_section: () => `/profile`,
  subscription: () => `/subscription-management`,
};
const TOAST_DURATION = 5000; // ms

const useNotifications = () => {
  const socket = useSocket();
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [toasts, setToasts] = useState([]);

  const joinedRef = useRef(false);
  const audioCtxRef = useRef(null);
  const toastTimersRef = useRef({});

  const doctorData = JSON.parse(
    localStorage.getItem("doctorData") || "{}"
  );

  const doctorId = doctorData?.id;

  //-----------------------------------------
  // Notification Tone
  //-----------------------------------------

  const playNotificationTone = useCallback(() => {
    try {
      if (!audioCtxRef.current) {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        audioCtxRef.current = new AudioContext();
      }

      const ctx = audioCtxRef.current;

      if (ctx.state === "suspended") {
        ctx.resume();
      }

      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = "sine";
      osc.frequency.setValueAtTime(880, ctx.currentTime);
      osc.frequency.setValueAtTime(660, ctx.currentTime + 0.12);

      gain.gain.setValueAtTime(0.15, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.35);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start();
      osc.stop(ctx.currentTime + 0.35);
    } catch (err) {
      console.error("Notification tone failed:", err);
    }
  }, []);

  //-----------------------------------------
  // Toast Queue
  //-----------------------------------------

  const dismissToast = useCallback((toastId) => {
    setToasts((prev) => prev.filter((t) => t.toastId !== toastId));

    if (toastTimersRef.current[toastId]) {
      clearTimeout(toastTimersRef.current[toastId]);
      delete toastTimersRef.current[toastId];
    }
  }, []);

  const pushToast = useCallback((notification) => {
    const toastId = `${notification.id}-${Date.now()}`;
    const toast = { ...notification, toastId };

    setToasts((prev) => [toast, ...prev].slice(0, 4)); // cap stack at 4

    toastTimersRef.current[toastId] = setTimeout(() => {
      dismissToast(toastId);
    }, TOAST_DURATION);
  }, [dismissToast]);

  //-----------------------------------------
  // Fetch Notifications
  //-----------------------------------------

  const fetchNotifications = useCallback(async () => {
    setLoading(true);

    await GetAPI(
      "/doctor/notifications?page=1&limit=20",
      (res) => {
        if (res.success) {
          setNotifications(res.notifications || []);

          setUnreadCount(
            (res.notifications || []).filter((n) => !n.is_read).length
          );
        }

        setLoading(false);
      }
    );
  }, []);

  //-----------------------------------------
  // Mark Read
  //-----------------------------------------

  const markAsRead = useCallback(
    async (notificationId) => {
      setNotifications((prev) =>
        prev.map((n) =>
          n.id === notificationId
            ? { ...n, is_read: true }
            : n
        )
      );

      setUnreadCount((prev) => Math.max(0, prev - 1));

      await PatchAPI(
        {
          url: `/doctor/notifications/${notificationId}/read`,
          data: {},
        },
        (res) => {
          if (!res.success) {
            fetchNotifications();
          }
        }
      );
    },
    [fetchNotifications]
  );

  //-----------------------------------------
  // Clear All
  //-----------------------------------------

  // const clearAllNotifications = useCallback(async () => {
  //   setNotifications([]);
  //   setUnreadCount(0);

  //   await PatchAPI(
  //     {
  //       url: "/doctor/notifications/read-all",
  //       data: {},
  //     },
  //     (res) => {
  //       if (!res.success) {
  //         fetchNotifications();
  //       }
  //     }
  //   );
  // }, [fetchNotifications]);
//-----------------------------------------
// Clear All
//-----------------------------------------

const clearAllNotifications = useCallback(async () => {
  const prevNotifications = notifications;
  const prevUnreadCount = unreadCount;

  // optimistic UI update
  setNotifications([]);
  setUnreadCount(0);

  await DeleteAPI(
    {
      url: "/doctor/notifications/clear",
      data: {},
    },
    (res) => {
      if (!res?.success) {
        // rollback on failure
        setNotifications(prevNotifications);
        setUnreadCount(prevUnreadCount);
      }
    }
  );
}, [notifications, unreadCount]);
  //-----------------------------------------
  // Click Notification (from dropdown or toast)
  //-----------------------------------------

  const handleNotificationClick = useCallback(
    (notification) => {
      if (!notification.is_read) {
        markAsRead(notification.id);
      }

      const route = REDIRECT_MAP[notification.redirect_to];

      if (route) {
        navigate(route(notification));
      }

      if (notification.toastId) {
        dismissToast(notification.toastId);
      }
    },
    [navigate, markAsRead, dismissToast]
  );

  //-----------------------------------------
  // Initial Fetch
  //-----------------------------------------

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  //-----------------------------------------
  // Socket Events
  //-----------------------------------------

  useEffect(() => {
    if (!socket) return;

    if (!socket.connected) {
      socket.connect();
    }

    const joinDoctorRoom = () => {
      if (!doctorId) return;

      console.log("Joining doctor room:", doctorId);

      socket.emit("join:doctor", {
        doctor_id: doctorId,
      });
    };

    if (socket.connected) {
      joinDoctorRoom();
    } else {
      socket.once("connect", joinDoctorRoom);
    }

    socket.on("join:doctor:ack", (data) => {
      console.log("Joined Room:", data);
      joinedRef.current = true;
    });

    socket.on("doctor:notification", (payload) => {
      console.log("Notification Received:", payload);

      const { event, data } = payload;

      if (event !== "new_notification") return;

      setNotifications((prev) => {
        if (prev.some((n) => n.id === data.id)) {
          return prev;
        }

        return [data, ...prev];
      });

      setUnreadCount((prev) => prev + 1);
      playNotificationTone();
      pushToast(data);
    });

    socket.on("doctor:notification:unread_count", ({ unread_count }) => {
      console.log("Unread Count:", unread_count);
      setUnreadCount(unread_count);
    });

    socket.onAny((event, ...args) => {
      console.log("Socket Event:", event, args);
    });

    return () => {
      socket.off("join:doctor:ack");
      socket.off("doctor:notification");
      socket.off("doctor:notification:unread_count");
      socket.off("connect", joinDoctorRoom);
      socket.offAny();
    };
  }, [socket, doctorId, playNotificationTone, pushToast]);

  //-----------------------------------------
  // Cleanup toast timers on unmount
  //-----------------------------------------

  useEffect(() => {
    return () => {
      Object.values(toastTimersRef.current).forEach(clearTimeout);
    };
  }, []);

  return {
    notifications,
    unreadCount,
    loading,
    toasts,
    dismissToast,
    markAsRead,
    markAllAsRead: clearAllNotifications,
    handleNotificationClick,
    refetch: fetchNotifications,
  };
};

export default useNotifications;